import { useEffect } from 'react';
import clsx from 'clsx';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { UserManagement } from 'components/UserManagement/UserManagement';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useLocale } from 'hooks/useLocale';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { getEnvironment } from 'utils/environmentHelper/environmentHelper';
import { PATH_NAMES } from 'utils/routes/pathNames';
import styles from './userManagement.module.css';

export const UserManagementPage = () => {
  const navigate = useNavigate();
  const { isUK } = useLocale();
  const { introducerType, checkIntroducerPermission } = useIntroducerData();
  const hasAccessToUserManagement =
    isUK &&
    introducerType !== 'partner' &&
    checkIntroducerPermission('can_manage_account_users');

  useEffect(() => {
    if (!hasAccessToUserManagement) {
      navigate(PATH_NAMES.home());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAccessToUserManagement]);

  if (!hasAccessToUserManagement) return null;

  return (
    <BaseLayout
      pageTitle="User management | Introducer Portal"
      className={clsx(styles.layout, {
        [styles.layoutWithBanner]: getEnvironment() === 'staging',
      })}
    >
      <UserManagement />
      <ToastContainer hideProgressBar position="bottom-right" />
    </BaseLayout>
  );
};
